/* Simple jQuery Equal Heights @version 1.5.1. Copyright (c) 2013 Matt Banks. Dual licensed under the MIT and GPL licenses. */
!function(a){a.fn.equalHeights=function(){var b=0,c=a(this);return c.each(function(){var c=a(this).innerHeight();c>b&&(b=c)}),c.css("height",b)},a("[data-equal]").each(function(){var b=a(this),c=b.data("equal");b.find(c).equalHeights()})}(jQuery);

window.timber = window.timber || {};

timber.cache = {
  // General
  html: $('html'),
  body: $('body'),
  equalHeight: $('.equal-height'),
  breadcrumbs: $('.breadcrumb'),

  // Navigation
  navigation: $('#accessibleNav'),
  menuToggle: $('.menu-toggle'),

  // Home Page
  carousel: $('.flexslider'),

  // Product Page
  mainImage: $('#productPhotoImg'),
  thumbImages: $('#productThumbs').find('a.product-photo-thumb'),
  newImage: null,
  shareButtons: $('.social-sharing'),

  // Collection Pages
  collectionFilters: $('#collectionFilters'),
  toggleFilterBtn: $('#toggleFilters')
}

timber.init = function () {
  timber.cache.html.removeClass('no-js').addClass('js');

  // Run on load
  timber.accessibleNav();
  timber.toggleMenu();
  timber.flexslider();
  timber.productImageSwitch();
  timber.equalHeights();
  timber.toggleFilters();

  timber.socialSharing();
}

timber.accessibleNav = function () {
  var nav = timber.cache.navigation,
      allLinks = nav.find('a'),
      topLevel = nav.children('li').find('a'),
      parents = nav.find('.site-nav--has-dropdown'),
      subMenus = nav.find('.site-nav--dropdown');

  // Mouseenter
  parents.on('mouseenter', function() {
    $(this).addClass('nav-hover');
  });

  // Mouseout
  parents.on('mouseout', function() {
    $(this).removeClass('nav-hover');
  });

  // Focus
  allLinks.focus(function(e) {
    handleFocus($(this));
  });

  // Blur
  allLinks.blur(function(e) {
    topLevel.removeClass('nav-focus');
    subMenus.attr('aria-hidden', 'true');
  });

  // accessibleNav private methods
  function handleFocus (el) {
    var subMenu = el.next('ul');
        hasSubMenu = subMenu.hasClass('site-nav--dropdown') ? true : false,
        isSubItem = $('.site-nav--dropdown').has(el).length;

    // Add focus class for top level items, or keep menu shown
    if ( !isSubItem ) {
      topLevel.removeClass('nav-focus');
      el.addClass('nav-focus');
    } else {
      el.closest('.site-nav--has-dropdown').find('a').addClass('nav-focus');
      el.closest('.site-nav--dropdown').attr('aria-hidden', 'false');
    }

    // Toggle aria-hidden attribute for top level items
    if ( hasSubMenu ) {
      if (subMenu.attr('aria-hidden') == 'true') {
        subMenu.attr('aria-hidden', 'false');
      } else {
        subMenu.attr('aria-hidden', 'true');
      }
    }

  }
}

timber.toggleMenu = function () {
  timber.cache.menuToggle.on('click', function() {
    timber.cache.body.toggleClass('show-nav');
  });
}

timber.flexslider = function () {
  if ( timber.cache.carousel.length ) {
    timber.cache.carousel.flexslider({
      animation: 'slide',
      slideshowSpeed: 5500,
      animationSpeed: 500,
      pauseOnHover: true,
      keyboard: false
    });
  }
}

timber.productImageSwitch = function () {
  if ( !timber.cache.thumbImages.length ) {
    return;
  }

  // Switch the main image with one of the thumbnails
  // Note: this does not change the variant selected, just the image
  timber.cache.thumbImages.on('click', function(e) {
    e.preventDefault();
    timber.cache.newImage = $(this).attr('href');
    timber.cache.mainImage.attr({ src: timber.cache.newImage });
  });
}

timber.socialSharing = function () {
  var buttons = timber.cache.shareButtons,
      permalink = buttons.data('permalink'),
      shareLinks = buttons.find('a'),
      socialCounts = buttons.find('span.share-count');

  
    // Get share stats from respective APIs
    var fbLink = $('.share-facebook'),
        twitLink = $('.share-twitter'),
        pinLink = $('.share-pinterest'),
        googleLink = $('.share-google'),
        fbShares, twitShares, pinShares, googleShares;

    if ( fbLink.length ) {
      $.getJSON('//graph.facebook.com/?id=' + permalink + '&callback=?', function(data) {
        fbShares = data.shares;
        if (!fbShares) {
          fbShares = 0;
        }
        fbLink.find('.share-count').text(fbShares).addClass('is-loaded');
      });
    };

    if ( twitLink.length ) {
      $.getJSON('//cdn.api.twitter.com/1/urls/count.json?url=' + permalink + '&callback=?', function(data) {
        twitShares = data.count;
        twitLink.find('.share-count').text(twitShares).addClass('is-loaded');
      });
    };

    if ( pinLink.length ) {
      $.getJSON('//api.pinterest.com/v1/urls/count.json?url=' + permalink + '&callback=?', function(data) {
        pinShares = data.count;
        pinLink.find('.share-count').text(pinShares).addClass('is-loaded');
      });
    };

    if ( googleLink.length ) {
      // Can't currently get Google+ count with JS, so just pretend it loaded
      googleLink.find('.share-count').addClass('is-loaded');
    };
  

  
    // Share popups
    shareLinks.on('click', function(e) {
      e.preventDefault();
      var el = $(this),
          popup = el.attr('class'),
          link = el.attr('href'),
          w = 700,
          h = 400;

      // Set popup sizes
      switch (popup) {
        case 'share-twitter':
          h = 300;
          break;
        case 'share-fancy':
          w = 480;
          h = 720;
          break;
        case 'share-google':
          w = 500;
          break;
      }

      window.open(link, popup, 'width=' + w + ', height=' + h);
    });
  
}

timber.equalHeights = function () {
  if ( timber.cache.equalHeight.length ) {
    // Short timeout to let fonts load
    setTimeout(function() {
      timber.cache.equalHeight.equalHeights();
    }, 200);
  }
}

timber.toggleFilters = function () {
  if ( !timber.cache.collectionFilters.length ) {
    return;
  }

  timber.cache.toggleFilterBtn.on('click', function() {
    timber.cache.toggleFilterBtn.toggleClass('is-active');
    timber.cache.collectionFilters.slideToggle(200);

    // Scroll to top of filters if user is down the page a bit
    if ( $(window).scrollTop() > timber.cache.breadcrumbs.offset().top ) {
      $('html, body').animate({
        scrollTop: timber.cache.breadcrumbs.offset().top
      });
    }
  });
}

// Initialize Timber's JS on docready
$(function() {
  window.timber.init();
});